import ModalHeader from '../ModalHeader/ModalHeader'
import styles from './FilterModaReports.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import CustomModal from '../UI/CustomModal/CustomModal'
import { useState } from 'react'
import FilterCompanyMobile from '../FilterCompanyMobile/FilterCompanyMobile'
import { GetCompaniesResponseType } from '../../redux/actions/types'
import FilterPlacesMobile from '../FIlterPlacesMobile/FilterPlacesMobile'
import CustomButton from '../UI/CustomButton/CustomButton'
import FilterReportMobile from '../FilterEstablishmentMobile/FilterEstablishmentMobile'

interface Props {
  onClickHandler: () => void
  dateBlock: JSX.Element
  establishmentOptions: (
    | {
        value: number
        label: string
      }
    | {
        value: string
        label: string
      }
  )[]
  setEstablishment: (selected: any) => void
  creatorOptions: {
    value: string
    label: string
  }[]
  setCreator: (selected: any) => void
  placeOptions: {
    value: string
    label: string
  }[]
  filteredPlaceOptions?: {
    value: string
    label: string
  }[]
  selectedEstablishment?: string
  clientsOptions: (
    | {
        value: number
        label: string | null
      }
    | {
        value: string
        label: string
      }
  )[]
  setSelectedClients: (selected: any) => void
  setSelectedPlaces: (selected: any) => void
}

const FilterModalModalReports: React.FC<Props> = ({
  onClickHandler,
  dateBlock,
  establishmentOptions,
  setEstablishment,
  creatorOptions,
  setCreator,
  placeOptions,
  filteredPlaceOptions,
  selectedEstablishment,
  setSelectedPlaces,
  clientsOptions,
  setSelectedClients,
}) => {
  const [filterManagers, setFilterManagers] = useState(false)
  const [filterEstablishment, setFilterEstablishment] = useState(false)
  const [filterPlaces, setFilterPlaces] = useState(false)
  const [filterClient, setFilterClient] = useState(false)

  const currentPlaceOptions = filteredPlaceOptions || placeOptions
  const isPlacesDisabled =
    !selectedEstablishment ||
    selectedEstablishment === '' ||
    !filteredPlaceOptions ||
    filteredPlaceOptions.length === 0

  return (
    <div className={styles.filterModal}>
      <CustomModal visible={filterEstablishment} setVisible={setFilterEstablishment}>
        <FilterReportMobile
          title='Площадки'
          setFilterData={setEstablishment}
          filterData={establishmentOptions}
          onClickHandler={() => setFilterEstablishment(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <CustomModal visible={filterManagers} setVisible={setFilterManagers}>
        <FilterReportMobile
          title='Менеджеры'
          setFilterData={setCreator}
          filterData={creatorOptions}
          onClickHandler={() => setFilterManagers(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <CustomModal visible={filterPlaces} setVisible={setFilterPlaces}>
        <FilterReportMobile
          title='Залы'
          setFilterData={setSelectedPlaces}
          filterData={currentPlaceOptions}
          onClickHandler={() => setFilterPlaces(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <CustomModal visible={filterClient} setVisible={setFilterClient}>
        <FilterReportMobile
          title='Клиенты'
          setFilterData={setSelectedClients}
          filterData={clientsOptions}
          onClickHandler={() => setFilterClient(false)}
          closeFilter={onClickHandler}
        />
      </CustomModal>
      <div className={styles.header}>
        <ModalHeader title='Фильтры' onClickHandler={onClickHandler} />
      </div>
      <div className={styles.content}>
        <div onClick={() => setFilterManagers(true)} className={styles.itemContainer}>
          <div>Менеджер </div>
          <img src={arrowLeft} />
        </div>
        <div onClick={() => setFilterEstablishment(true)} className={styles.itemContainer}>
          <div>Площадка</div>
          <img src={arrowLeft} />
        </div>
        <div
          onClick={() => !isPlacesDisabled && setFilterPlaces(true)}
          className={`${styles.itemContainer} ${isPlacesDisabled ? styles.disabled : ''}`}
        >
          <div>
            Зал
            {isPlacesDisabled && (
              <span className={styles.disabledHint}> (сначала выберите площадку)</span>
            )}
          </div>
          <img src={arrowLeft} />
        </div>
        <div onClick={() => setFilterClient(true)} className={styles.itemContainer}>
          <div>Клиент</div>
          <img src={arrowLeft} />
        </div>
        {dateBlock}
      </div>
      <div className={styles.footerContainer}>
        <CustomButton
          title='Применить'
          className={styles.filtersBtn}
          type='button'
          onClick={() => {
            onClickHandler()
          }}
        />
      </div>
    </div>
  )
}

export default FilterModalModalReports
